module.exports = __webpack_public_path__ + "static/media/down-arrow.dc22cd49.svg";